export default __webpack_public_path__ + "static/Economic Model Whitepaper - Korean-aa42a9a3f650eaf52887f60fa308f38b.pdf";